/* --------------------------------------------------------------- */

/*
  This file is used by `lib/core/LcApi.js`; as we're sharing the 
  library with different apps, each app needs to create it's own 
  config.

  Production: https://leadcapture-api.oq.com
  Staging:    https://oq-leadcapture-api.staging.alligence.com
  Asana task: https://app.asana.com/0/1200941836607829/1199969853244253

  Staging web:    https://oq-servicedesk.staging.alligence.com/
  Production web: https://oq-servicedesk.alligence.com/
   
*/
const LcConfig = {
  server_url: 'https://oq-leadcapture-api.staging.alligence.com',  /* staging */
  //server_url: 'https://oq-leadcapture-api.staging.alligence.com',  /* production */
  base_url: 'api/v1',
  api_key: 'd547e4c72951409dac77acf07114e77c',
  event_title: "OQ Events",
  use_badge_scan: false,
};

/* --------------------------------------------------------------- */

export default LcConfig;

/* --------------------------------------------------------------- */
